// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_VtO","controls":"styles_controls__2ns40","charLimit":"styles_charLimit__3LpqR","input":"styles_input__2cHbT","send":"styles_send__1M9ul"};